import { render, staticRenderFns } from "./InitializeSessionComponent.vue?vue&type=template&id=6689709c&scoped=true&"
import script from "./InitializeSessionComponent.vue?vue&type=script&lang=ts&"
export * from "./InitializeSessionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6689709c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex})
